// Guards a page with unsaved changes against both in-app navigation (via the
// data router's useBlocker) and hard unloads (beforeunload). Use one guard per
// page — react-router only supports a single active blocker at a time.
import { useEffect } from 'react';
import { useBlocker } from 'react-router';

const MESSAGE = 'You have unsaved changes. Leave this page and discard them?';

const useUnsavedChangesGuard = (dirty) => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => dirty
      && currentLocation.pathname !== nextLocation.pathname,
  );

  useEffect(() => {
    if (blocker.state !== 'blocked') return;
    // A native confirm is the right tool here: it's synchronous, blocks the
    // navigation deterministically, and matches the beforeunload prompt.
    // eslint-disable-next-line no-alert
    if (window.confirm(MESSAGE)) blocker.proceed();
    else blocker.reset();
  }, [blocker]);

  useEffect(() => {
    if (!dirty) return undefined;
    const handler = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [dirty]);
};

export default useUnsavedChangesGuard;
